<script>
import {generateUUID, generatePK} from "@/utils";
import {getSubscribersList, addSubscriber} from "@/api/subscribers";
import {getLocations} from "@/api/locations";
import CreditCardDetails from "./CreditCardDetails.vue";
import {validationMixin} from 'vuelidate'
import {required, minLength, maxLength, alphaNum, email} from 'vuelidate/lib/validators'

export default {
  name: "add-subscriber-dialog",
  mixins: [validationMixin],
  components: {
    CreditCardDetails
  },
  validations: {
    form: {
      fname: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(255)
      },
      lname: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(255)
      },
      email: {
        required,
        email
      }
    }
  },
  data() {
    return {
      show: false,
      valid: true,
      form: {
        name: "",
        email: "",
        location_id: null,
        subscriber_list_id: "",
        cards: []
      },
      subscribersLists: [],
      locations: [],
      selectedItems: [],
      spinning: false,

    };
  },
  async mounted() {
    this.subscribersLists = await getSubscribersList();
    this.locations = await getLocations();
    this.form.cards.push(this.generateNewCard());
  },
  computed: {
    fnameErrors() {
      const errors = []
      if (!this.$v.form.fname.$dirty) return errors
      !this.$v.form.fname.required && errors.push('First Name is required.')
      !this.$v.form.fname.minLength && errors.push('First Name must be at least 3 characters long')
      !this.$v.form.fname.maxLength && errors.push('You have exceeded the number of allowed characters')
      return errors
    },
    lnameErrors() {
      const errors = []
      if (!this.$v.form.lname.$dirty) return errors
      !this.$v.form.lname.required && errors.push('Last Name is required.')
      !this.$v.form.lname.minLength && errors.push('Last Name must be at least 3 characters long')
      !this.$v.form.lname.maxLength && errors.push('You have exceeded the number of allowed characters')
      return errors
    },
    emailErrors() {
      const errors = []
      if (!this.$v.form.email.$dirty) return errors
      !this.$v.form.email.email && errors.push('Must be valid e-mail')
      !this.$v.form.email.required && errors.push('E-mail is required')
      return errors
    },
    visible() {
      return this.$store.getters["getAddDialogVisible"];
    },
    subscribersOptions() {
      return [
        ...this.subscribersLists.map(list => {
          return {
            value: list.id,
            text: list.name
          };
        })
      ];
    },
    locationsOptions() {
      return [
        {value: null, text: "Please select", name: "Please select"},
        ...this.locations.map(list => {
          return {
            value: list.id,
            text: list.name + '\n' + list.full_address,
            name: list.name,
            full_address: list.full_address
          };
        })
      ];
    },
    likesAllItems() {
      return this.selectedItems.length === this.subscribersOptions.length;
    },
    likesSomeItem() {
      return this.selectedItems.length > 0 && !this.likesAllItems;
    },
    icon() {
      if (this.likesAllItems) return "mdi-close-box";
      if (this.likesSomeItem) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    }
  },
  methods: {
    clearForm() {
      this.form = {
        name: "",
        email: "",
        location_id: null,
        subscriber_list_id: "",
        cards: []
      }
      this.form.cards.push(this.generateNewCard());
    },
    hide() {
      this.$store.commit("hideAddDialog");
      this.clearForm();

    },
    onSubmit() {

      this.clearForm();
    },
    addSubscriberCard() {
      this.form.cards.push(this.generateNewCard());
    },
    async addSubscriber() {
      let areCardsValid = this.form.cards.every(card => card.isValid);

      if (this.$refs.form.validate() && areCardsValid) {
        const payload = JSON.parse(
            JSON.stringify({
              profile: {
                name: this.form.fname + ' ' + this.form.lname,
                first_name: this.form.fname,
                last_name: this.form.lname,
                email: this.form.email
              },
              cards: this.form.cards.map(card => card.cardDetails),
              location_id: this.form.location_id,
              subscriber_list_id: generatePK()


            })
        );
        console.log(payload)
        this.spinning = true;
        const response = await addSubscriber(payload);

        this.spinning = false;
        if (response != null) {
          this.$bvToast.toast(`Added`, {
            title: "Subscriber",
            autoHideDelay: 3000,
            appendToast: false,
            variant: "info"
          });
          setTimeout(() => {
            this.hide();
            this.spinning = false;
            this.$store.dispatch("getSubscribers");
          }, 2000);
        } else {
          this.$bvToast.toast(`${response}`, {
            title: 'Failed',
            autoHideDelay: 3000,
            appendToast: false,
            variant: "error"
          });
        }
      }
    },
    handleChange(newObject) {
      this.form.cards.forEach((card, index) => {
        if (card.cardDetails.id === newObject.id) {
          Object.assign(this.form.cards[index].cardDetails, newObject);
        }
      });
    },
    handleCardValidity(validityObj) {
      const changedCard = this.form.cards.filter(
          card => card.cardDetails.id == validityObj.id
      )[0];
      changedCard.isValid = validityObj.isValid;
    },
    handleRemoved({id}) {
      if(this.form.cards.length <= 1){
        this.$bvToast.toast("Can't remove the default.", {
          title: 'Failed',
          autoHideDelay: 5000,
          appendToast: true,
          variant: "error"
         });
      }else{
        const newCards = this.form.cards.filter(
            card => card.cardDetails.id !== id
        );
        this.form.cards = newCards;
      }
    },
    generateNewCard() {
      return {
        isValid: false,
        cardDetails: {
          id: generatePK(),
          card_brand: "",
          card_digit: "",
          first_six_digits: "",
          last_four_digits: ""
        }
      };
    },
    toggle() {
      this.$nextTick(() => {
        if (this.likesAllItems) {
          this.selectedItems = [];
        } else {
          let data = [];
          for (let i = 0; i < this.subscribersOptions.length; i++) {
            let item = this.subscribersOptions[i];
            data.push(item.value);
          }

          this.selectedItems = data;

        }
      });
    }
  }
};
</script>

<template>
  <v-dialog v-model="visible" persistent scrollable width="500px">
    <v-card>
      <v-card-title class="headline">
        Add Subscriber
      </v-card-title>
      <v-card-text>
        <v-form
            v-on:submit.prevent="onSubmit"
            method="POST"
            v-model="valid"
            ref="form"
            lazy-validation
        >
          <!-- START FORM INPUTS -->
          <v-container>
            <v-row>
              <v-col cols="6">
                <v-text-field
                    v-model="form.fname"
                    :error-messages="fnameErrors"
                    :counter="255"
                    label="First Name*"
                    required
                    @input="$v.form.fname.$touch()"
                    @blur="$v.form.fname.$touch()"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                    v-model="form.lname"
                    :error-messages="lnameErrors"
                    :counter="255"
                    label="Last Name*"
                    required
                    @input="$v.form.lname.$touch()"
                    @blur="$v.form.lname.$touch()"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                    v-model="form.email"
                    label="Email*"
                    :error-messages="emailErrors"
                    @input="$v.form.email.$touch()"
                    @blur="$v.form.email.$touch()"
                    required
                >
                </v-text-field>
              </v-col>
              <v-col cols="12">
                <v-select
                    v-model="form.location_id"
                    :items="locationsOptions"
                    label="Location*"
                    :rules="[v => !!v || 'This is required']"
                    required
                >
                <template slot="item" slot-scope="{ item, attrs, on }">
                  <v-list-item v-on="on" v-bind="attrs">
                      <v-list-item-content v-if="item.full_address != null">
                        <v-list-item-title>
                        {{item.name}}
                        </v-list-item-title>
                        <v-list-item-subtitle>
                        {{item.full_address}}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-content v-else>
                        {{item.name}}
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-select>
              </v-col>

            </v-row>

            <b-table-simple borderless small caption-top responsive>
              <caption>
                Subscriber Cards
              </caption>
              <b-tbody>
                <template v-for="card in form.cards">
                  <credit-card-details
                      :key="card.cardDetails.id"
                      @input="handleChange"
                      @removed="handleRemoved"
                      v-on:isValid="handleCardValidity"
                      :value="card.cardDetails"
                  />
                </template>
              </b-tbody>
            </b-table-simple>
            <v-btn color="green darken-1" text @click="addSubscriberCard">
              Add Card
            </v-btn>
          </v-container>
          <small>*indicates required field</small>
          <!-- END -->
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="mr-4" depressed tile @click="hide">
          Close
        </v-btn>
        <v-btn
            class="mr-4"
            depressed
            tile
            @click="addSubscriber"
            v-if="!spinning"
        >
          Add Subscriber
        </v-btn>
        <b-spinner v-show="spinning" label="Spinning"></b-spinner>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
